import { Box, Icon, Link } from '@bitrise/bitkit';
import ActivityList from '@/components/ActivityList/ActivityList';

const NotificationsDrawer = (): JSX.Element => {
  return (
    <Box>
      <ActivityList limit={8} />
      <Link key="show-all-notifications" href="/activity" textColor="purple.50" marginLeft="48" paddingY="16">
        View all <Icon name="ArrowMoveRight" width="16" />
      </Link>
    </Box>
  );
};

export default NotificationsDrawer;
